/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokenResponseModel } from '../../models/token-response-model';

export interface AuthenticationValidateMfaCode$Params {

/**
 * MFA code
 */
  mfaCode?: string;
}

export function authenticationValidateMfaCode(http: HttpClient, rootUrl: string, params?: AuthenticationValidateMfaCode$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenResponseModel>> {
  const rb = new RequestBuilder(rootUrl, authenticationValidateMfaCode.PATH, 'post');
  if (params) {
    rb.query('mfaCode', params.mfaCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenResponseModel>;
    })
  );
}

authenticationValidateMfaCode.PATH = '/v1/Authentication/ValidateMfaCode';
